const toDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatDate = (value?: string | null): string =>
  toDate(value)?.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }) ?? "—";

export const formatDateTime = (value?: string | null): string =>
  toDate(value)?.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }) ?? "—";

// Human-friendly "time ago" for last-active.
export const timeAgo = (value?: string | null): string => {
  const d = toDate(value);
  if (!d) return "—";
  const min = Math.floor((Date.now() - d.getTime()) / 60000);
  if (min < 1) return "Just now";
  if (min < 60) return `${min}m ago`;
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
};

const UNKNOWN_CURRENCY = "UNKNOWN";

export const formatMoney = (amount: number, currency: string | null): string => {
  if (!currency || currency === UNKNOWN_CURRENCY) return amount.toFixed(2);
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
};
